import { Capacitor } from "@capacitor/core";
import { loadSecuritySettings } from "./appSecurity";

let clearTimer: ReturnType<typeof setTimeout> | null = null;

async function writeClipboard(text: string) {
  if (Capacitor.isNativePlatform()) {
    try {
      const { Clipboard } = await import("@capacitor/clipboard");
      await Clipboard.write({ string: text });
      return;
    } catch {
      /* fall through */
    }
  }
  await navigator.clipboard.writeText(text);
}

/** Copy text and clear clipboard after security timeout (no read required). */
export async function copyText(text: string, opts?: { sensitive?: boolean }) {
  if (!text) return;
  await writeClipboard(text);
  if (clearTimer) clearTimeout(clearTimer);
  const s = await loadSecuritySettings();
  const sec = s.clipboardClearSec;
  if (!sec || sec <= 0) return;
  if (opts?.sensitive === false) return;
  clearTimer = setTimeout(() => {
    void writeClipboard("").catch(() => undefined);
  }, sec * 1000);
}
